<script>
    import {incrementItemInCart, decrementItemInCart} from "./cart-store.js";
    import OrderButton from "../components/OrderButton.svelte";
    import { t } from '../core/i18n/language-store';

    export let item;
    export let publishConfig;
    export let tenantKey;

    let expanded = false;
</script>

<style>

    .item {
        display: flex;
        align-items: center;
    }
    .right {
        gap: .25em;
    }
    .name {
        font-family: Roboto Condensed, sans-serif;
        font-size: 16px;
        font-weight: 800;
        line-height: 120%;
        text-transform: uppercase;
        color: var(--main-font-color);
        padding-right: .5rem;
    }
    .name--small {
        font-size: 12px;
    }
    .name--expanded {
        color: var(--accent-color);
    }
    .plus {
        font-family: PT Mono, sans-serif;
    }
    .weight {
        color: var(--secondary-font-color);
    }
    .price {
        font-family: PT Mono, sans-serif;
        color: var(--accent-color);
        font-size: .9rem;
    }
    .mods {
        color: var(--secondary-font-color);
    }

    .item-details {
        font-size: .9em;
        height: 0;
        overflow: hidden;
        transition: height .3s ease;
    }
    .item-details--expanded {
        padding: .5rem 0;
        height: auto;
    }
</style>

<div class="item">
    <div class="left flex-fill" on:click={() => expanded = !expanded}>
        <div class="name"
             class:name--small={item?.name?.length > 20}
             class:name--expanded={expanded}>
            <span class="plus">{#if expanded}-{:else}+{/if}</span> { item.name || $t('cart.unnamed') }</div>
    </div>

    <div class="right flex ai-center">
        <div class="price nowrap price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
            <span>{ item.price }</span>
            <span>{publishConfig?.currency || ''}</span>
        </div>
        <OrderButton record={{_orderedItems: item.count}}
                     on:add={() => incrementItemInCart(item, item.price, item.priceIndex, item.mods)}
                     on:remove={() => decrementItemInCart(item, item.price, item.priceIndex, item.mods)}
        ></OrderButton>
    </div>
</div>

<div class="item-details" class:item-details--expanded={expanded}>

    {#if (item.weight !== undefined && item.weight !== null)}
        <div class="weight">{ item.weight}</div>
    {/if}

    {#if (item.modsDescription?.length > 0)}
        <div class="mods">{ item.modsDescription }</div>
    {/if}
</div>

